import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { EventLandingService } from '@app/modules/event-landing-page/services/event-landing.service'
import { Contact } from '@app/modules/personas/interfaces/persona-landing-option.interface'
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o'

@Component({
  selector: 'ngx-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss'],
  imports: [CommonModule, CarouselModule]
})
export class ContactCardComponent implements OnInit {
  contactList: Contact
  initials: string
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    navSpeed: 1000,
    navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
    responsive: {
      0: {
        items: 1
      }
    },
    nav: true
  }
  constructor(private eventLandingService: EventLandingService) {}

  ngOnInit(): void {
    this.contactList = this.eventLandingService.contactsList
    this.initials = this.getInitials(this.contactList.contactInfo.company_name)
  }

  /**
   * Returns the first letter(s) of the input string's word(s).
   * @param {string} input - The string to process.
   * @returns {string} - The first letter of the first word or first letters of first two words in uppercase.
   */
  getInitials(input: string): string {
    const words = input.trim().split(' ')
    return words
      .slice(0, 2)
      .map((word) => word[0].toUpperCase())
      .join('')
  }
}
